import { render, staticRenderFns } from "./ChallengeApproveList.vue?vue&type=template&id=ad903890&"
import script from "./ChallengeApproveList.vue?vue&type=script&lang=js&"
export * from "./ChallengeApproveList.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeApproveList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports